import { Link } from '@tanstack/react-router'

import { EmptyState } from '@/components/ui/States'
import { Panel } from '@/components/ui/Panel'

export function NotFoundPage() {
  return (
    <Panel>
      <EmptyState
        title="That page does not exist."
        hint={
          <>
            Pick a section from the sidebar, or start with{' '}
            <Link to="/executions" className="text-primary underline-offset-2 hover:underline">
              executions
            </Link>
            .
          </>
        }
      />
    </Panel>
  )
}
